import { AgxTypography } from '@urbanx/agx.ui-components2'

import './LoadingState.scss'

const LoadingState = () => {
  return (
    <div className="loadingState">
      <AgxTypography
        id={'loadingStateText'}
        type={'body'}
        size={'small'}
        color={'var(--text-tertiary)'}
      >
        Loading...
      </AgxTypography>
    </div>
  )
}

export default LoadingState
